module.exports = __webpack_public_path__ + "../resources/img/bg-copy-3-light.697bb0a2.svg";